<template>
  <navigation-layout ref='navigationlayout'>
    <h1 slot="title">{{title}}</h1>
    <h3 slot="abstract">{{abstract}}</h3>
    <main>
      <md-tabs class="md-transparent" md-alignment="fixed"  @md-changed="getActiveTab">
        <md-tab id="tab-facility-info" md-label="Facility Info">
          <facility-info :parentref='this' />
        </md-tab>
        <md-tab id="tab-staff" md-label="Staff" >
          <facility-staff :parentref='this' />
        </md-tab>
        <md-tab id="tab-integration-info" md-label="Integration info">
          <facility-integration-info :parentref='this' />
        </md-tab>
      </md-tabs>
    </main>
  </navigation-layout>
</template>

<script>
import FacilityInfo from '@/components/views/facility/facility-info'
import FacilityIntegrationInfo from '@/components/views/facility/facility-integration-info'
import FacilityStaff from '@/components/views/facility/facility-staff'
import NavigationLayout from '@/components/layouts/navigation'
import RepositoryService from '@/services/repositoryService'

export default {
  name: 'facility-menu',
  data: () => ({
    title: RepositoryService.session.selectedFacility.companyName,
    abstract: 'Manage a facility',
    actualTab: null
  }),
  components: {
    FacilityInfo,
    FacilityIntegrationInfo,
    FacilityStaff,
    NavigationLayout
  },
  created: function () {
    this.$route.meta.breadcrumb = RepositoryService.session.selectedFacility.chainName ? [{
      name: RepositoryService.session.selectedBillingCompany.companyName,
      link: 'selectbillingcompany'
    },
    {
      name: RepositoryService.session.selectedFacility.chainName,
      link: 'chainMenu'
    },
    {
      name: RepositoryService.session.selectedFacility.companyName
    }
    ] : [{
      name: RepositoryService.session.selectedBillingCompany.companyName,
      link: 'selectbillingcompany'
    },
    {
      name: RepositoryService.session.selectedFacility.companyName
    }
    ]
  },
  methods: {
    getActiveTab (activeTab) {
      this.actualTab = activeTab
    }
  }
}

</script>
